import React, { useState, useEffect, useMemo } from "react";
import { getData, putData } from "../../../../../services/library";
import { logEventos } from "../../../../../services/services";
import { Dialog, DialogContent, FormControl, MenuItem, Select, InputLabel, DialogContentText, TextField, Grid, Box, Typography, Button, Autocomplete, Alert, AlertTitle } from '@mui/material';
import Notify from "../../../../Notify";
import { UpdateDisabled } from "@mui/icons-material";

export default function ModalCondicion(props) {

    const [condTemporal, setcondTemporal] = useState(props.condSelected);
    const clienteId = props.datos?.id || props.datosCli;

    // console.log("condtempora", condTemporal);
    

    useEffect(() => {
        // Cada vez que se abre el modal, se inicializa la condicon  temporal con el actual
        setcondTemporal(props.condSelected);
    }, [props.condSelected]);

    const [notificacion, setNotificacion] = useState({
        open: false,
        mensaje: "",
        severity: "",
        color: "",
    });

    const style = {
        backgroundColor: "#ffffff",
        width: "100%",
    };

    const updateCond = async (e) => {
        putData(e,
            `/clientes/${clienteId}`,
            {
                id_condicionpago: condTemporal.id,  // Guardamos la condicion temporal
                // id_subsegmento:null,
                usuario: localStorage.getItem('user')
            },
            setNotificacion,
            // props.actualizar(),
            // Actualizamos la condicion en `AddPedidos`
            props.setcondSelected(condTemporal)
        );
        logEventos('Cambio de condicion en cliente', 'Addpedido', 'Cliente granel', localStorage.getItem('user'));

    };


    return (
        <Dialog maxWidth="md" fullWidth open={props.open} onClose={props.onCerrar} >
            <DialogContent>
                {/* <Alert severity="warning">
                    <AlertTitle>Atención</AlertTitle>
                    El segmento de este cliente es desconocido.-
                </Alert> */}
                <DialogContentText>
                    <Box p={2}>
                        <Typography variant="caption" display="block" gutterBottom>
                            Elegir una condición de pago para modificar.-
                        </Typography>
                    </Box>
                </DialogContentText>
                <form autoComplete="off" onSubmit={updateCond}>
                    <Autocomplete
                        value={condTemporal}
                        disableClearable

                        options={props.condiciones}
                        onChange={(event, newValue) => setcondTemporal(newValue)}  // Cambiamos el estado temporal
                        getOptionLabel={(option) => option.condicion}
                        renderInput={(params) => (
                            <TextField {...params} style={style} label="Condiciones" variant="outlined" />
                        )}
                    />
                    <Grid
                        container
                        justifyContent="space-between"
                        alignItems="flex-end"
                        mt={2}
                    >
                        <Button variant="contained"
                            onClick={() => {
                                props.onClose()

                            }}
                            color="error">
                            Volver
                        </Button>

                        <Button
                            variant="contained"
                            type="submit"
                            color={"success"}
                        >
                            Actualizar
                        </Button>
                    </Grid>
                </form>
            </DialogContent>
            {notificacion && notificacion.open ? (
                <Notify
                    mensaje={notificacion.mensaje}
                    open={notificacion.open}
                    color={notificacion.color}
                    handleClose={props.onClose}
                    severity={notificacion.severity}
                />
            ) : null}
        </Dialog>

    )



}